import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { DataTable } from "primeng/primeng";
import { PaginationComponent } from "../../pagination/pagination.component";
import { PaginationService } from "../../../core/pagination/paginator.service";
import { PaymentService } from "../../../core/payments/payments.service";
import * as _ from "lodash";
import Tooltip from "tooltip.js";
import { AuthService } from "../../../core/auth/auth.service";
import { OpenPayService } from "../../../core/openpay/openpay.service";
import {
  ElectronicPaymentModel,
  TransfersModel,
} from "../../../core/payments/electronic-payment.model";
import { MessageService } from "primeng/components/common/messageservice";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EAccountService } from "./e-account.service";
import { Games } from "./games";
import { DatePipe } from "@angular/common";

declare var $;

@Component({
  //selector: 'pagos',
  templateUrl: "e-account.component.html",
  styleUrls: ["e-account.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class EAccountComponent
  extends PaginationComponent
  implements OnInit, AfterViewInit
{
  /*pagin: any = { page: 0, size: 4, path: 'people/get-all' }*/
  //itemsSelected: PaymentModel[] = [];
  itemsSelected: TransfersModel[] = [];
  actualPage: number = 0;
  comisionesAmount: number = 0;
  totalAmount: number = 0;

  @ViewChild("dt")
  dt: DataTable;
  games: Games[];

  private exportToolTip;

  addWinnerForm: FormGroup;

  constructor(
    private paginationService: PaginationService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private openpay: OpenPayService,
    private messageService: MessageService,
    private paymentService: PaymentService,
    private eAccountService: EAccountService,
    private modalService: NgbModal,
    public datepipe: DatePipe
  ) {
    super(messageService, paginationService);
    this.addWinnerForm = formBuilder.group({
      username: ["", Validators.required],
      game: [null, Validators.required],
      drawNumber: ["", Validators.required],
      drawDate: [new Date(), Validators.required],
      drawAmount: ["", Validators.required],
      awardAmount: ["", Validators.required],
      finalAwardAmount: ["", Validators.required],
    });
    this.getGames();
  }

  ngAfterViewInit() {
    //$('#export').tooltip();
    this.exportToolTip = new Tooltip($("#export"), {
      placement: "button",
      title: "Solo se descargaran los registros de la pagina actual",
      trigger: "hover",
    });
  }

  ngOnInit() {
    this.data = { page: 0, size: 1000, path: "payments" };
    console.log("Token en e-account", this.openpay.deviceSessionId);
    this.getUserInfoFromService();
    super.ngOnInit();
  }

  private getUserInfoFromService() {
    this.authService.getCustomerByUsername().subscribe(
      (response) => {
        console.log("Mostramos la informacion del usuario", response);
      },
      (err) => {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: err,
        });
      }
    );
  }

  paginate(event) {
    this.data.size = event.rows;
    this.actualPage = event.page;
    this.getPage(this.actualPage);

    //event.first = Index of the first record
    //event.rows = Number of rows to display in new page
    //event.page = Index of the new page
    //event.pageCount = Total number of pages
  }

  getUser() {
    console.log("El usuario es:", this.authService.user);
  }

  doElectronicPayout() {
    this.loading = true;

    this.paymentService
      .doElectronicPayout(this.fillModel())
      .finally(() => {
        this.itemsSelected = [];
        this.getPage(this.actualPage);
      })
      .subscribe(
        (response) => {
          this.totalAmount = 0;
          this.getUserInfoFromService();
          console.log("mostramos la respuesta: ", response);
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: "Se realizo la peticion con exito",
          });
        },
        (error) => {
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: error,
          });
        }
      );
  }

  private fillModel(): ElectronicPaymentModel {
    let model: ElectronicPaymentModel = new ElectronicPaymentModel();
    model.deviceSessionId = this.openpay.deviceSessionId;
    model.listOfWinners = this.itemsSelected;
    return model;
  }

  addReference(value) {
    //this.itemsSelected = [value.data];
    /*if (value.data.account !== 'OK') {
         this.itemsSelected = _.remove(this.itemsSelected, item => {
        console.log(item.wagerReferenceId, value.data.wagerReferenceId, item.wagerReferenceId == value.data.wagerReferenceId)
        return item.wagerReferenceId == value.data.wagerReferenceId
      });
    } else {*/
    _.remove(
      this.itemsSelected,
      (item) =>
        item.id.wagerReferenceIdKey === value.data.id.wagerReferenceIdKey
    );
    this.itemsSelected = _.concat(this.itemsSelected, value.data);
    this.getTotales();
    //}
  }

  /*  cancelReference(value){
      _.remove(this.itemsSelected, item => {
          console.log(item.wagerReferenceId, value.data.wagerReferenceId, item.wagerReferenceId == value.data.wagerReferenceId)
          return item.wagerReferenceId == value.data.wagerReferenceId
        });
    }*/

  onRowSelect(event) {
    /*console.log(event);
    if (event.data.account !== 'OK') {
      //this.itemsSelected.splice(event.data, 1);
      let itemsTmp = this.itemsSelected;
      this.itemsSelected = [];
      _.remove(itemsTmp, item => {
        console.log(item.wagerReferenceId, event.data.wagerReferenceId, item.wagerReferenceId == event.data.wagerReferenceId)
        return item.wagerReferenceId == event.data.wagerReferenceId
      });


      this.itemsSelected = _.concat(this.itemsSelected, itemsTmp);
    }
    console.log(this.itemsSelected);*/
    this.getTotales();
  }

  onRowUnselect(event) {
    this.getTotales();
  }

  getTotales() {
    this.comisionesAmount = 0;
    this.totalAmount = 0;
    _.forEach(this.itemsSelected, (item) => {
      /*this.comisionesAmount += item.fee;
      this.totalAmount += item.total2Paid;*/
      this.totalAmount =
        parseFloat(this.totalAmount.toString()) + parseFloat(item.amountPrize);
    });
  }

  display: boolean = false;

  showDialog() {
    this.display = true;
  }

  addThelotterWinner(modal) {
    this.modalService.open(modal, {}).result.then(
      (result) => {
        console.log(`Closed with: ${result}`);
        let form = this.addWinnerForm.value;
        this.eAccountService
          .addWinner({
            username: form.username,
            game: form.game.name,
            drawNumber: form.drawNumber,
            drawDate: form.drawDate.getTime(),
            drawAmount: form.drawAmount,
            awardAmount: form.awardAmount,
            finalAwardAmount: form.finalAwardAmount,
            productCodeId: form.game.code,
          })
          .subscribe(
            () => {
              this.messageService.add({
                severity: "success",
                summary: "",
                detail: "Usuario agregado.",
              });
            },
            () => {
              this.messageService.add({
                severity: "error",
                summary: "",
                detail: "Apuesta no encontrada.",
              });
            }
          );
      },
      (reason) => {}
    );
  }

  private getGames() {
    this.eAccountService.getAvailableGames().subscribe((games) => {
      this.games = games;
      this.addWinnerForm.patchValue({
        game: this.games[0],
      });
    });
  }

  exportCSV() {
    const dtToDownload = this.dt;
    /*dtToDownload.value.forEach((data) => {
      data.drawDate = this.datepipe.transform(data.drawDate, "dd-MM-yyyy");
    });
    */
    dtToDownload.exportCSV();
  }

  getDate(date) {
    if (!isNaN(date)) {
      return this.datepipe.transform(date, "dd-MM-yyyy");
    } else {
      return date;
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/payments/electronic-account/e-account.component.ts